module.exports = __webpack_public_path__ + "img/preparing-practicing_new.b4c5f457.jpg";